<template lang="pug">
  v-app
    v-navigation-drawer(v-model="drawer" app clipped)
      v-list(dense)
        v-list-item(link to="/")
          v-list-item-action
            v-icon mdi-information-outline
          v-list-item-content
            v-list-item-title About this app
        v-list-item(link to="/animation")
          v-list-item-action
            v-icon mdi-play-circle-outline
          v-list-item-content
            v-list-item-title Animation
        v-list-item(link to="/chart")
          v-list-item-action
            v-icon mdi-chart-line
          v-list-item-content
            v-list-item-title Graph

    v-app-bar(app clipped-left)
      v-app-bar-nav-icon(@click.stop="drawer = !drawer")
      v-toolbar-title Driver model application
      v-spacer
      v-menu(text-center min-width="200"  :close-on-content-click="false" @click.stop="" offset-y :setting="setting" v-for="(setting, key) in settings" :key="key")
        template(v-slot:activator="{ on }")
          v-btn( icon v-on="on")
            v-icon {{setting.icon}}
        setting-card(:setting="setting")
    v-content
      router-view

    v-footer(app)
      span &copy; 2019

</template>
<style lang="scss"></style>
<script>
import { SettingCard } from "@/components/index";

export default {
  components: { SettingCard },
  data: function() {
    return {
      drawer: null
    };
  },
  computed: {
    settings() {
      return this.$store.state.simulationSettings.settings;
    }
  },
  created() {
    this.$vuetify.theme.dark = true;
    this.$store.dispatch("simulation/initialize");
  }
};
</script>

<style>
html {
  overflow-y: auto !important;
}
</style>
